export default {
  initValTask: {
    id: 0,
    qty: 1,
    weight: 0,
    uom_code: '',
    remarks: '',
    break_time: 0,
    start_time: '',
    finish_time: '',
    duration_time: 0,
    unit_name_code: '',
    equipment_code: '',
    estimation_detail_code: '',
    estimation_header_code: '',
    billing_start_time: '',
    billing_finish_time: '',
    billing_dur_time: 0
  },
  showModalStatus: {
    isOpen: false,
    srCode: '',
    taskCode: '',
    taskName: ''
  },
  initValDropDown: {
    uom_weight: '',
    unit_name_code: '',
    estimation_detail_code: '',
  }
}

export const SR_STATUS = {
  FINALIZED: 'Finalized',
}
